import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import BrandStrip from '../components/BrandStrip';
import CertificationsStrip from '../components/CertificationsStrip';
import ProductsSection from '../components/ProductsSection';
import AboutSection from '../components/AboutSection';
import IndustriesSection from '../components/IndustriesSection';
import ProcessSection from '../components/ProcessSection';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import BlogSection from '../components/BlogSection';
import FAQSection from '../components/FAQSection';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

export default function HomePage() {
  return (
    <div>
      <SEO path="/" />
      <Navbar />
      <Hero />
      <BrandStrip />
      <ProductsSection />
      <CertificationsStrip />
      <AboutSection />
      <IndustriesSection />
      <ProcessSection />
      <WhyChooseUs />
      <BlogSection />
      <Testimonials />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}
